module.exports = __webpack_public_path__ + "img/chargers-map.2c9dc5cc.png";